
    import "src/shared/components/RetailerInfoSlider/index.module.scss?farm_css_modules";
    
    export default {"ant-drawer-close": `ant-drawer-close-1215586a`,"ant-form-item-label": `ant-form-item-label-1215586a`,"col": `col-1215586a`,"editButtonGroup": `editButtonGroup-1215586a`,"formItemInput": `formItemInput-1215586a`,"headingText": `headingText-1215586a`,"inputElement": `inputElement-1215586a`,"retailerTitle": `retailerTitle-1215586a`,"row": `row-1215586a`}
    